import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { htmlSafe } from '@ember/template';
import { guidFor } from '@ember/object/internals';

export default class PaperDataTableCell extends Component {
  // Stable DOM id so the edit dialog can locate this cell for positioning.
  elementId = guidFor(this);
  @tracked showEdit = false;

  get style() {
    let width = this.args.width;
    if (width) {
      return htmlSafe(`width: ${Number(width)}px;`);
    }
    return undefined;
  }

  @action
  handleClick() {
    if (this.args.onClick) {
      this.args.onClick();
    }
    this.showEdit = true;
  }

  @action
  close() {
    if (this.args.onClose) {
      this.args.onClose(this);
    }
  }

  @action
  toggleEdit() {
    this.showEdit = !this.showEdit;
  }
}
